// extracted by mini-css-extract-plugin
export default {"main":"screen_main__Vt4es","panel":"screen_panel__l9B0N","title":"screen_title__T+6+1"};